import { render, staticRenderFns } from "./FinesDriverShow.vue?vue&type=template&id=ddb5f594&scoped=true&"
import script from "./FinesDriverShow.vue?vue&type=script&lang=js&"
export * from "./FinesDriverShow.vue?vue&type=script&lang=js&"
import style0 from "./FinesDriverShow.vue?vue&type=style&index=0&id=ddb5f594&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../shared/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddb5f594",
  null
  
)

export default component.exports